export default __webpack_public_path__ + "static/media/QR_Error.3e65edb2.gif";